import { useEffect } from "react";

type SeoMeta = {
  title?: string;
  description?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
  canonicalUrl?: string;
  robots?: string;
};

const upsertMeta = (key: string, value: string, attr: "name" | "property") => {
  let tag = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, key);
    tag.setAttribute("data-managed", "seo");
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", value);
};

const upsertLink = (rel: string, href: string) => {
  let tag = document.head.querySelector(`link[rel="${rel}"]`);
  if (!tag) {
    tag = document.createElement("link");
    tag.setAttribute("rel", rel);
    tag.setAttribute("data-managed", "seo");
    document.head.appendChild(tag);
  }
  tag.setAttribute("href", href);
};

export default function SeoHead(meta: SeoMeta) {
  useEffect(() => {
    if (meta.title) document.title = meta.title;
    if (meta.description) upsertMeta("description", meta.description, "name");
    if (meta.robots) upsertMeta("robots", meta.robots, "name");
    if (meta.ogTitle) upsertMeta("og:title", meta.ogTitle, "property");
    if (meta.ogDescription) upsertMeta("og:description", meta.ogDescription, "property");
    if (meta.ogImage) upsertMeta("og:image", meta.ogImage, "property");
    if (meta.canonicalUrl) upsertLink("canonical", meta.canonicalUrl);
  }, [
    meta.title,
    meta.description,
    meta.robots,
    meta.ogTitle,
    meta.ogDescription,
    meta.ogImage,
    meta.canonicalUrl
  ]);

  return null;
}
